const defaultCustomMapData = {
    customMapData: [],
    pages: [],
    currentPage: 0
};

export default (state = defaultCustomMapData, action) => {
    switch(action.type) {
        case 'GET_CUSTOM_MAP_FROM_API':
            return {
                customMapData: action.customMap,
                currentPage: action.currentPage,
                pages: action.pages
            }
        default:
            return state
    }
}
